import React, { useEffect, useState } from "react";

export default function Header() {
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 12);
        onScroll();
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    const scrollTo = (id) => (e) => {
        e.preventDefault();
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    };

    return (
        <header
            data-testid="site-header"
            className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
                scrolled ? "tb-glass" : ""
            }`}
        >
            <div className="max-w-7xl mx-auto px-6 md:px-10 h-[68px] flex items-center justify-between">
                <a
                    href="/"
                    data-testid="brand-logo"
                    className="flex items-center gap-3"
                    aria-label="Tiltbox"
                >
                    <img
                        src="/logo.png"
                        alt="Tiltbox"
                        width="40"
                        height="40"
                        className="w-9 h-9 md:w-10 md:h-10 rounded-[10px] object-cover"
                    />
                    <span className="font-display text-white font-extrabold text-[20px] md:text-[22px] tracking-tight">
                        Tiltbox
                    </span>
                </a>

                <nav className="hidden md:flex items-center gap-10">
                    <a
                        data-testid="nav-features"
                        onClick={scrollTo("features")}
                        href="#features"
                        className="text-[13px] tracking-wide uppercase text-[var(--tb-text-body)] hover:text-[var(--tb-gold)] transition-colors"
                    >
                        Features
                    </a>
                    <a
                        data-testid="nav-showcase"
                        onClick={scrollTo("showcase")}
                        href="#showcase"
                        className="text-[13px] tracking-wide uppercase text-[var(--tb-text-body)] hover:text-[var(--tb-gold)] transition-colors"
                    >
                        Showcase
                    </a>
                </nav>

                <a
                    data-testid="header-cta"
                    href="https://apps.apple.com/us/app/tiltbox-io/id6761959954"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="tb-cta hidden md:inline-flex"
                >
                    Get Your Audit
                </a>
            </div>
        </header>
    );
}
